import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/** Condition-based numbering rules (workflow-definer /api/number-rules). */
@Injectable({ providedIn: 'root' })
export class NumberRuleService {

  private base = `${environment.apiBaseUrl}/api/number-rules`;

  constructor(private http: HttpClient) {}

  list(scope: 'quotation' | 'document') {
    return this.http.get<any>(`${this.base}?scope=${scope}`);
  }

  /** Replaces the WHOLE ordered list for a scope — order decides which rule wins, so a partial
   *  save could leave a company with competing fallbacks or none at all. */
  replace(scope: 'quotation' | 'document', rules: any[]) {
    return this.http.put<any>(`${this.base}?scope=${scope}`, rules);
  }
}
